import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { getFaqCategoriesInUsed, getFaqsByCategory } from "../services/faqService";
import FAQItem from "./faq/FAQItem";
import { paginatorTemplate } from "../helpers/paginatorTemplate";
import { Paginator } from "primereact/paginator";
import { getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";
import { getLocalizedField } from "../helpers/localizedHelper";
import NoData from "./nodata/NoData";

export const FaqList = ({props}) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filteredFaqs, setFilteredFaqs] = useState([]);
  const [expandedQuestionId, setExpandedQuestionId] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const language = getI18nLanguageFromLocalStorage();
  
  const onPageChange = (event) => {
    setFirst(event.first);
  };

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const catList = await getFaqCategoriesInUsed();
        setCategories(catList);
      } catch (err) {
        //console.error(err);
      }
    };
    loadInitialData();
  }, []);

  useEffect(() => {
    const loadFaqs = async () => {
      if (true) {
        try {
          const filter = {
            first: first,
            rows: rows,
            filters: null,
            multiSortMeta: [{
              field: "createdTime",
              order: -1,
            }],
          };
          const faqs = await getFaqsByCategory(filter, selectedCategory?.id);
          setFilteredFaqs(faqs.data);
          setTotalRecords(faqs.pagingInfo.totalRecordCount);

        } catch (err) {
          // setIsError(translations.errorMessage);
        }
      }
    };

    loadFaqs();
  }, [selectedCategory])

  const handleSelectCategory = (cat) => {
    setSelectedCategory(cat);
    setExpandedQuestionId(null);
  };

  const toggleQuestion = (qId) => {
    setExpandedQuestionId((prev) => (prev === qId ? null : qId));
  };

  return (
    <div className="flex flex-column">
      <div className="flex flex-column w-full py-45 px-35 gap-3">
        <div className="flex flex-row gap-2">
          <div className="flex justify-content-center align-items-center">
            <span className="pi pi-bookmark-fill text-primary-default text-125"></span>
          </div>
          <div className="keduall-typography heading-h4-normal-400 ">{props.faqList.title}</div>
        </div>
        <div className="flex w-full justify-content-start">
          <h1 className="keduall-typography heading-h1-semibold-600 text-default-txt">
            {props.faqList.subtitle}
          </h1>
        </div>
      </div>
        <div className="flex w-full flex-column justify-content-center align-items-center gap-6 px-35 pb-35 pt-0">
          <div className="flex flex-row keduall-tab-panel tab-panel-container bg-white flex-wrap w-full">
            <Button
              className={`w-max tab-label-button keduall-typography heading-h6-semibold-600 border-none ${selectedCategory === null ? 'active-button' : 'inactive-button'}`}
              onClick={() => handleSelectCategory(null)}
              label={props.faqList.allCategoryTitle}
            >
            </Button>
            {categories.length === 0 ? (
              <p></p>
            ) : (
              categories.map((cat) => {
                const isSelected = selectedCategory && selectedCategory.id === cat.id;
                return (
                  <Button
                    key={cat.id}
                    className={`w-max tab-label-button keduall-typography heading-h6-semibold-600 border-none ${isSelected ? 'active-button' : 'inactive-button'}`}
                    onClick={() => handleSelectCategory(cat)}
                    label={getLocalizedField(cat, "name", language)}
                  >
                  </Button>
                );
              })
            )}
          </div>
          <div className="flex w-full">
            <div className="flex flex-column  w-full">
              {filteredFaqs.length === 0 ? (
                <NoData message={props.faqList.noData} />
              ) : (
                filteredFaqs.map((faq) => {
                  const isExpanded = expandedQuestionId === faq.id;
                  const question = getLocalizedField(faq, "question", language);
                  const answer = getLocalizedField(faq, "answer", language);
                  return (
                    <FAQItem
                      key={faq.id}
                      props={{ ...faq, question, answer }}
                      isExpanded={isExpanded}
                      onClick={toggleQuestion}
                    />
                  );
                })
              )}
            </div>
          </div>
          {totalRecords > rows && 
            <Paginator
              template={paginatorTemplate}
              first={first}
              rows={rows}
              totalRecords={totalRecords}
              onPageChange={onPageChange}
              className="keduall-paginator"
            />
          }
        </div>
    </div>
  );
};
